import { B2CPolicy, IEnvironmentVariables } from 'src/environments/IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_SignUp_SignIn',
    signUpSignInRegence: 'B2C_1A_SignUp_SignIn_Regence',
    signUpSignInportalextsso: 'B2C_1A_SignUp_SignIn_portalextsso',
    resetPassword: 'B2C_1A_PasswordReset',
  },
  authorityBaseUrl: 'https://mncportalqat.b2clogin.com/tfp/mncportalqat.onmicrosoft.com',
};

const BASE_URL = 'https://portalqat.mynexuscare.com/';

const API_URL = {
  Platform: 'https://api-platform.portalqat.mynexuscare.com',
  HH: 'https://api-homehealth.portalqat.mynexuscare.com',
  PAC: 'https://api-pacim.portalqat.mynexuscare.com',
  DMEPOS: 'https://api-dmepos.portalqat.mynexuscare.com',
  SDoH: 'https://api-sdoh.portalqat.mynexuscare.com',
  SP: 'https://api-specialtyprograms.portalqat.mynexuscare.com',
  DocumentGateway: 'https://api-document-gateway.portalqat.mynexuscare.com',
  NotificationGateway: 'https://api-notification-gateway.portalqat.mynexuscare.com',
};

const consentScopes = [
  'https://mncportalqat.onmicrosoft.com/api/api.Write',
  'https://mncportalqat.onmicrosoft.com/api/api.Read',
  'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  production: true,
  b2cPolicies: b2cPolicies,
  baseUrl: BASE_URL,
  appInsightsConnectionString: 'InstrumentationKey=2f1980b4-43b4-4f64-bcff-a23de20318b3;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=27a5334a-86fa-4d4b-a955-d90e9c14c476',
  apiUrl: API_URL.HH,
  apiPlatformUrl: API_URL.Platform,
  apiDocumentUrl: API_URL.DocumentGateway,
  apiUrlPacIM: API_URL.PAC,
  apiDMEPOSUrl: API_URL.DMEPOS,
  apiSDoHUrl: API_URL.SDoH,
  apiSpecialtyProgramsUrl: API_URL.SP,
  apiNotificationsUrl: API_URL.NotificationGateway,
  routerUrl: 'https://resourcerouter.portalqat.mynexuscare.com',
  sdohUrl: 'https://sdoh.portalqat.mynexuscare.com/',
  codeManagementUrl: 'https://web-codemanagement.portalqat.mynexuscare.com',
  extssoBaseUrl: 'https://extsso.portalqat.mynexuscare.com/',
  hhProviderFinderUrl : 'https://carelonsolutions--full.sandbox.my.salesforce-sites.com/ProviderFinder',
  authConfig: {
    config: {
      auth: {
        clientId: 'a8044264-7310-4f2b-b77b-b6d3ce68b06f',
        postLogoutRedirectUri: BASE_URL,
        redirectUri: BASE_URL,
        knownAuthorities: ['mncportalqat.b2clogin.com'],
      },
      system: {},
    },
    angularConfig: {
      extraQueryParameters: {
        prompt: 'select_account',
      },
      consentScopes: [...consentScopes, 'openid', 'profile'],
      protectedResourceMap: [
        ...Object.values(API_URL).map((url) => [`${url}/*`, consentScopes]),
      ],
    },
  },
  registryUrl: `${API_URL.Platform}/api/app-registry`,
};


